import type { ReactElement } from 'react';
import React from 'react';

/**
 * TestInstancesFallback:
 * Fallback text when there are no assigned testInstances
 * @param year year that data is not found for
 */
export default function TestInstancesFallback({ year }: { year: string }): ReactElement {
  return (
    <div
      className="alert alert-info"
      role="alert"
      aria-live="polite"
      data-testid="test-instances-fallback"
    >
      <h4 className="alert-heading">No Assessments</h4>
      <p>The calendar year {year} does not have any assigned assessments</p>
      <hr />
      <p className="mb-0">Maybe try selecting a different year</p>
    </div>
  );
}
